// extracted by mini-css-extract-plugin
export default {"Header":"Intro_Header__Fl+Hw","Text":"Intro_Text__YXd7y"};